import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { IntroSection } from "./components/IntroSection";
import { HeroSection } from "./components/HeroSection";
import { StatisticsSection } from "./components/StatisticsSection";
import { CrySection } from "./components/CrySection";
import { SchoolSection } from "./components/SchoolSection";
import { ParentsSection } from "./components/ParentsSection";
import { HungerSection } from "./components/HungerSection";
import { MomentSection } from "./components/MomentSection";
import { TransitionSection } from "./components/TransitionSection";
import { ActionSection } from "./components/ActionSection";
import { SolutionSection } from "./components/SolutionSection";
import { SchoolIntroSection } from "./components/SchoolIntroSection";
import { CoffeeSection } from "./components/CoffeeSection";
import { CallToActionSection } from "./components/CallToActionSection";
import { ClosingSection } from "./components/ClosingSection";
import "./styles/globals.css";

export default function App() {
  return (
    <div className="w-full overflow-x-hidden">
      <Header />
      <main>
        <IntroSection />
        <HeroSection />
        <StatisticsSection />
        <CrySection />
        <SchoolSection />
        <ParentsSection />
        <HungerSection />
        <MomentSection />
        <TransitionSection />
        <ActionSection />
        <SolutionSection />
        <SchoolIntroSection />
        <CoffeeSection />
        <CallToActionSection />
        <ClosingSection />
      </main>
      <Footer />
    </div>
  );
}

